export default __webpack_public_path__ + "static/media/CNo.92-4.842955db.jpg";